(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lbl-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var DAY = 86400000;
    var IST_OFFSET = 330 * 60000;

    // "Order in 5h 33m & get it by Mon, 26 Oct": the time left before today's cut-off
    // and the delivery date for an order placed now, both worked out in India time.
    function initCountdown(card) {
      if (!card) return;
      var left = card.querySelector('[data-lbl-left]');
      var by = card.querySelector('[data-lbl-by]');
      if (!left || !by) return;
      var cutoff = Math.min(24, Math.max(1, parseInt(card.dataset.cutoff, 10) || 24));
      var days = Math.max(1, parseInt(card.dataset.days, 10) || 8);
      var skipSunday = card.dataset.skipSunday === 'true';
      var format;
      try {
        format = new Intl.DateTimeFormat('en-IN', { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' });
      } catch (error) {
        return;
      }
      function tick() {
        // Shift to India time and read it back with UTC getters.
        var now = Date.now() + IST_OFFSET;
        var orderDay = now - (now % DAY);
        var cut = orderDay + cutoff * 3600000;
        if (now >= cut) {
          orderDay += DAY;
          cut += DAY;
        }
        var minutes = Math.max(1, Math.floor((cut - now) / 60000));
        var hours = Math.floor(minutes / 60);
        left.textContent = (hours ? hours + 'h ' : '') + (minutes % 60) + 'm';
        var arrival = new Date(orderDay + days * DAY);
        if (skipSunday && arrival.getUTCDay() === 0) arrival = new Date(arrival.getTime() + DAY);
        by.textContent = format.format(arrival);
        card.classList.add('is-live');
      }
      tick();
      if (card.lblTimer) clearInterval(card.lblTimer);
      card.lblTimer = setInterval(tick, 20000);
      document.addEventListener('visibilitychange', function () {
        if (!document.hidden && card.isConnected) tick();
      });
    }

    function initHero(root) {
      if (!root || root.dataset.lblReady === 'true') return;
      root.dataset.lblReady = 'true';

      root.querySelectorAll('[data-lbl-step]').forEach(function (button) {
        button.addEventListener('click', function () {
          var input = button.parentElement.querySelector('input');
          if (!input) return;
          var min = parseInt(input.min, 10) || 1;
          var max = parseInt(input.max, 10) || 99;
          var next = (parseInt(input.value, 10) || min) + Number(button.dataset.lblStep);
          input.value = Math.min(max, Math.max(min, next));
        });
      });

      var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
      var panels = tabs.map(function (tab) {
        return document.getElementById(tab.getAttribute('aria-controls'));
      });
      function selectTab(index, moveFocus) {
        tabs.forEach(function (tab, i) {
          var selected = i === index;
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          tab.tabIndex = selected ? 0 : -1;
          if (panels[i]) panels[i].hidden = !selected;
        });
        if (moveFocus) tabs[index].focus();
      }
      if (tabs.length > 1) {
        selectTab(0, false);
        tabs.forEach(function (tab, i) {
          tab.addEventListener('click', function () {
            selectTab(i, false);
          });
          tab.addEventListener('keydown', function (event) {
            if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
            event.preventDefault();
            var step = event.key === 'ArrowRight' ? 1 : -1;
            selectTab((i + step + tabs.length) % tabs.length, true);
          });
        });
      }

      var track = root.querySelector('[data-lbl-slides]');
      var slides = track ? Array.prototype.slice.call(track.querySelectorAll('[data-lbl-slide]')) : [];
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-lbl-dots] span'));
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-lbl-thumbs] button'));
      function setActive(index) {
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === index);
        });
        thumbs.forEach(function (thumb, i) {
          thumb.classList.toggle('is-active', i === index);
          if (i === index) {
            thumb.setAttribute('aria-current', 'true');
          } else {
            thumb.removeAttribute('aria-current');
          }
        });
      }
      if (track && slides.length > 1 && 'IntersectionObserver' in window) {
        var slideObserver = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) setActive(slides.indexOf(entry.target));
            });
          },
          { root: track, threshold: 0.6 }
        );
        slides.forEach(function (slide) {
          slideObserver.observe(slide);
        });
        thumbs.forEach(function (thumb, i) {
          thumb.addEventListener('click', function () {
            track.scrollTo({ left: slides[i].offsetLeft, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
            setActive(i);
          });
        });
      }

      initCountdown(root.querySelector('[data-lbl-countdown]'));

      var sticky = root.querySelector('[data-lbl-sticky]');
      var mainBuy = root.querySelector('[data-lbl-main-buy]');
      if (sticky && mainBuy && 'IntersectionObserver' in window) {
        var finalCta = document.querySelector('[data-lbl-final]');
        var pastBuy = false;
        var nearEnd = false;
        var update = function () {
          var show = pastBuy && !nearEnd;
          sticky.classList.toggle('is-visible', show);
          sticky.inert = !show;
        };
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            pastBuy = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          });
          update();
        }).observe(mainBuy);
        if (finalCta) {
          new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              nearEnd = entry.isIntersecting || entry.boundingClientRect.top < 0;
            });
            update();
          }).observe(finalCta);
        }
      }
    }

    if (!window.lblBuyNowBound) {
      window.lblBuyNowBound = true;
      document.addEventListener('submit', function (event) {
        var form = event.target;
        if (!(form instanceof HTMLFormElement) || !form.hasAttribute('data-lbl-buy')) return;
        event.preventDefault();
        if (form.dataset.lblBusy === 'true') return;
        form.dataset.lblBusy = 'true';
        var buttons = document.querySelectorAll('button[type="submit"][form="' + form.id + '"]');
        Array.prototype.slice.call(buttons).concat(Array.prototype.slice.call(form.querySelectorAll('button[type="submit"]'))).forEach(function (button) {
          button.setAttribute('aria-busy', 'true');
        });
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        // Empty the cart first so checkout holds exactly the quantity chosen here.
        fetch(root + 'cart/clear.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin'
        })
          .catch(function () {})
          .then(function () {
            HTMLFormElement.prototype.submit.call(form);
          });
      });
      window.addEventListener('pageshow', function (event) {
        if (!event.persisted) return;
        document.querySelectorAll('form[data-lbl-buy]').forEach(function (form) {
          form.dataset.lblBusy = 'false';
        });
        document.querySelectorAll('.lbl [aria-busy="true"]').forEach(function (button) {
          button.removeAttribute('aria-busy');
        });
      });
    }

    function run() {
      document.querySelectorAll('[data-lbl-hero]').forEach(initHero);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target && event.target.querySelector('[data-lbl-hero]');
      if (root) initHero(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
